"use client";
import { j as v } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as n from "react";
import { forwardRef as F } from "react";
import { t as A } from "./tv.config-BuYIgndg.mjs";
import { useMediaQuery as Y } from "./useMediaQuery.js";
import { useTabContext as q } from "./TabContext.js";
import K from "./Select.js";
import { u as Q } from "./useEventCallback-CjuAhyNz.mjs";
import { u as G } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { C as J } from "./CompositeRoot-DqjHHBWD.mjs";
import { t as D } from "./styleHooks-CMOZRnYj.mjs";
import { u as I } from "./TabsRootContext-CBt3a0fg.mjs";
import { u as U, T as X } from "./TabsListContext-Bcp97w7K.mjs";
import { u as Z } from "./useForcedRerendering-D5LqFHht.mjs";
import { u as V } from "./useOnMount-JHtE6teb.mjs";
import { u as tt } from "./useRenderElement-B8V3_e8R.mjs";
import { u as et } from "./DirectionContext-D4ZBZehF.mjs";
let j = 0;
function nt(t) {
  return j += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${j}`;
}
const ot = '!function(){const t=document.currentScript.previousElementSibling;if(!t)return;const e=t.closest(\'[role="tablist"]\');if(!e)return;const f=e.querySelector("[data-selected]");if(!f)return;if(0===f.offsetWidth||0===e.offsetWidth)return;const o=getComputedStyle(e).direction,i=f.offsetLeft-e.clientLeft,r="ltr"===o?e.scrollWidth-f.offsetLeft-f.offsetWidth-e.clientLeft:f.offsetLeft-e.clientLeft,s=f.offsetTop-e.clientTop,n=e.scrollHeight-f.offsetTop-f.offsetHeight-e.clientTop,c=f.offsetWidth,l=f.offsetHeight;function d(e,f){t.style.setProperty(`--active-tab-${e}`,`${f}px`)}d("left",i),d("right",r),d("top",s),d("bottom",n),d("width",c),d("height",l),c>0&&l>0&&t.removeAttribute("hidden")}();';
let H = /* @__PURE__ */ function(t) {
  return t.activeTabLeft = "--active-tab-left", t.activeTabRight = "--active-tab-right", t.activeTabTop = "--active-tab-top", t.activeTabBottom = "--active-tab-bottom", t.activeTabWidth = "--active-tab-width", t.activeTabHeight = "--active-tab-height", t;
}({});
const rt = {
  ...D,
  selectedTabPosition: () => null,
  selectedTabSize: () => null
}, _ = /* @__PURE__ */ n.forwardRef(function(i, s) {
  const {
    className: a,
    render: e,
    renderBeforeHydration: o = !1,
    ...u
  } = i, {
    getTabElementBySelectedValue: r,
    orientation: f,
    tabActivationDirection: L,
    value: d
  } = I(), {
    tabsListRef: c
  } = U(), [E] = n.useState(() => nt("tab")), [S, N] = n.useState(!1), {
    value: R
  } = I(), M = et();
  V(() => N(!0));
  const C = Z();
  n.useEffect(() => {
    if (d != null && c.current != null && typeof ResizeObserver < "u") {
      const l = new ResizeObserver(() => {
        C();
      });
      return l.observe(c.current), () => {
        l.disconnect();
      };
    }
  }, [d, c, C]);
  let b = 0, g = 0, T = 0, x = 0, p = 0, h = 0, m = !1;
  if (d != null && c.current != null) {
    const l = r(d), y = c.current;
    m = !0, l != null && (b = l.offsetLeft - y.clientLeft, g = M === "ltr" ? y.scrollWidth - l.offsetLeft - l.offsetWidth - y.clientLeft : l.offsetLeft - y.clientLeft, T = l.offsetTop - y.clientTop, x = y.scrollHeight - l.offsetTop - l.offsetHeight - y.clientTop, p = l.offsetWidth, h = l.offsetHeight);
  }
  const W = n.useMemo(() => m ? {
    left: b,
    right: g,
    top: T,
    bottom: x
  } : null, [b, g, T, x, m]), $ = n.useMemo(() => m ? {
    width: p,
    height: h
  } : null, [p, h, m]), O = n.useMemo(() => {
    if (m)
      return {
        [H.activeTabLeft]: `${b}px`,
        [H.activeTabRight]: `${g}px`,
        [H.activeTabTop]: `${T}px`,
        [H.activeTabBottom]: `${x}px`,
        [H.activeTabWidth]: `${p}px`,
        [H.activeTabHeight]: `${h}px`
      };
  }, [b, g, T, x, p, h, m]), P = m && p > 0 && h > 0, w = n.useMemo(() => ({
    orientation: f,
    selectedTabPosition: W,
    selectedTabSize: $,
    tabActivationDirection: L
  }), [f, W, $, L]), k = tt("span", i, {
    state: w,
    ref: s,
    props: [{
      role: "presentation",
      style: O,
      hidden: !P
      // do not display the indicator before the layout is settled
    }, u, {
      "data-instance-id": S && o ? void 0 : E,
      suppressHydrationWarning: !0
    }],
    customStyleHookMapping: rt
  });
  return R == null ? null : /* @__PURE__ */ v.jsxs(n.Fragment, {
    children: [k, !S && o && /* @__PURE__ */ v.jsx("script", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: ot
      },
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (_.displayName = "TabsIndicator");
const it = [], B = /* @__PURE__ */ n.forwardRef(function(i, s) {
  const {
    activateOnFocus: a = !0,
    className: e,
    loop: o = !0,
    render: u,
    ...r
  } = i, {
    getTabElementBySelectedValue: f,
    onValueChange: L,
    orientation: d,
    value: c,
    setTabMap: E,
    tabActivationDirection: S
  } = I(), [N, R] = n.useState(0), M = n.useRef(null), C = st(
    c,
    // the old value
    d,
    M,
    f
  ), b = Q((p, h) => {
    if (p !== c) {
      const m = C(p);
      L(p, m, h);
    }
  }), g = n.useMemo(() => ({
    orientation: d,
    tabActivationDirection: S
  }), [d, S]), T = {
    "aria-orientation": d === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, x = n.useMemo(() => ({
    activateOnFocus: a,
    highlightedTabIndex: N,
    onTabActivation: b,
    setHighlightedTabIndex: R,
    tabsListRef: M,
    value: c
  }), [a, N, b, R, M, c]);
  return /* @__PURE__ */ v.jsx(X.Provider, {
    value: x,
    children: /* @__PURE__ */ v.jsx(J, {
      render: u,
      className: e,
      state: g,
      refs: [s, M],
      props: [T, r],
      customStyleHookMapping: D,
      highlightedIndex: N,
      enableHomeAndEndKeys: !0,
      loop: o,
      orientation: d,
      onHighlightedIndexChange: R,
      onMapChange: E,
      disabledIndices: it
    })
  });
});
process.env.NODE_ENV !== "production" && (B.displayName = "TabsList");
function z(t, i) {
  const {
    left: s,
    top: a
  } = t.getBoundingClientRect(), {
    left: e,
    top: o
  } = i.getBoundingClientRect(), u = s - e, r = a - o;
  return {
    left: u,
    top: r
  };
}
function st(t, i, s, a) {
  const e = n.useRef(null);
  return G(() => {
    if (t == null || s.current == null) {
      e.current = null;
      return;
    }
    const o = a(t);
    if (o == null) {
      e.current = null;
      return;
    }
    const {
      left: u,
      top: r
    } = z(o, s.current);
    e.current = i === "horizontal" ? u : r;
  }, [i, a, s, t]), n.useCallback((o) => {
    if (o === t)
      return "none";
    if (o == null)
      return e.current = null, "none";
    if (o != null && s.current != null) {
      const u = a(o);
      if (u != null) {
        const {
          left: r,
          top: f
        } = z(u, s.current);
        if (e.current == null)
          return e.current = i === "horizontal" ? r : f, "none";
        if (i === "horizontal") {
          if (r < e.current)
            return e.current = r, "left";
          if (r > e.current)
            return e.current = r, "right";
        } else {
          if (f < e.current)
            return e.current = f, "up";
          if (f > e.current)
            return e.current = f, "down";
        }
      }
    }
    return "none";
  }, [a, i, e, s, t]);
}
const at = A({
  base: [
    "Tab__List",
    "relative",
    "z-0",
    "flex",
    "gap-1",
    "p-1",
    "rounded-xl",
    "sm:outline",
    "sm:outline-1",
    "outline-gray-300",
    "sm:bg-common-white"
  ],
  variants: {}
}), ct = A({
  base: [
    "Tab__Indicator",
    "h-[calc(var(--active-tab-height))]",
    "absolute",
    "top-1/2",
    "left-0",
    "z-[-1]",
    "w-[var(--active-tab-width)]",
    "-translate-y-1/2",
    "translate-x-[var(--active-tab-left)]",
    "rounded-lg",
    "bg-primary-light/25",
    "transition-all",
    "duration-300",
    "ease-in-out"
  ],
  variants: {}
}), lt = F((t, i) => {
  const { children: s, className: a, value: e, onValueChange: o, ...u } = t, { defaultValue: r, value: f } = q(), L = Y("sm");
  return /* @__PURE__ */ v.jsxs(
    B,
    {
      className: at({
        className: typeof a == "string" ? a : ""
      }),
      ref: i,
      ...u,
      render: ({ className: d, ...c }) => L ? /* @__PURE__ */ v.jsx(K, { defaultValue: r, value: f, ...c }) : /* @__PURE__ */ v.jsx("div", { ...c, className: d }),
      children: [
        s,
        /* @__PURE__ */ v.jsx(_, { className: ct({}) })
      ]
    }
  );
});
lt.displayName = "TabList";
export {
  lt as default
};
